<template>
  <div class="publicMain">
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="回访时间">
          <el-col :span="11">
            <el-input v-model="form.name"></el-input>
          </el-col>
          <el-col :span="2" style="text-align:center">-</el-col>
          <el-col :span="11">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="add" size="add">新增</el-button>
      <!-- <el-button type="primary" @click="addClassify" size="mini">新增分类</el-button> -->
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip
                class="item"
                style="color:#dd3020;"
                effect="light"
                content="删除"
                placement="top-start"
              >
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
            </div>
            <div v-else-if="item.type=='state'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.state==1">待审核</el-tag>
                <el-tag v-if="scope.row.state==2" type="success">通过</el-tag>
                <el-tag v-if="scope.row.state==3" type="danger">不通过</el-tag>
              </div>
            </div>
            <div v-else-if="item.type=='sex'">
              <div style="text-align:center;">
                <span v-if="scope.row.sex==0" type="success">男</span>
                <span v-if="scope.row.sex==1" type="primary">女</span>
              </div>
            </div>
            <div v-else-if="item.type=='nature'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.nature==1" type="success">农村户口</el-tag>
                <el-tag v-if="scope.row.nature==2" type="warning">城镇户口</el-tag>
                <el-tag v-if="scope.row.nature==3" type="danger">无户口</el-tag>
              </div>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible" width="40%">
      <div style="width:100%; width: 90%;margin: 0px auto;">
        <el-form
          v-if="visible"
          :model="ruleForm"
          :rules="rulesDialog"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="家庭电话">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
          <el-form-item label="详细地址">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="家庭电话">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
          <el-form-item label="回访内容">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="满意度">
                <el-select v-model="form.region" placeholder="请选择活动区域">
                  <el-option label="区域一" value="shanghai"></el-option>
                  <el-option label="区域二" value="beijing"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
            <el-col :span="8">
              <el-form-item label="回访人">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="回访时间">
                <el-date-picker
                  v-model="form.name"
                  type="datetime"
                  format="yyyy-MM-dd hh:mm:ss"
                  value-format="yyyy-MM-dd hh:mm:ss"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
          <div class="button">
            <div class="button-mid">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button type="info" @click="visible=false">返回</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllChildrenPolicyList,
  childrenHomePolicyEdit,
  childrenHomePolicyDelete,
  helpManageFamilyLogList,
  helpListOut,
} from "../api";
//救助管理
import request from "@/utils/request.js";
import childrenPolicyPublicityDialog from "../components/childrenPolicyPublicityDialog.vue";
import childrenPolicyPublicityDialogClassify from "../components/childrenPolicyPublicityDialogClassify.vue";
import upload from "@/component/componentsP/upImg.vue";
export default {
  components: {
    childrenPolicyPublicityDialog,
    childrenPolicyPublicityDialogClassify,
    upload,
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      title: "", //dialog的标题
      visible: false, //dialog的标题
      //模糊查询数据
      form: {},
      fileList: [],
      typeImg: "",
      visibleShow: false, //
      //table表格的column
      tableColumn: [
        {
          prop: "name",
          label: "姓名",
        },
        {
          prop: "rescueName",
          label: "年龄",
        },
        {
          prop: "money",
          label: "联系电话",
        },
        {
          prop: "releaseTime",
          label: "地址",
        },
        {
          prop: "releaseTime",
          label: "服务类型",
        },
        {
          prop: "money",
          label: "服务项目",
        },
        {
          prop: "releaseTime",
          label: "服务提供方",
        },
        {
          prop: "releaseTime",
          label: "回访人",
        },
        {
          prop: "releaseTime",
          label: "回访时间",
        },
        {
          prop: "releaseTime",
          label: "满意度",
        },
        {
          label: "操作",
          type: "button",
        },
      ],
      //table表格的数据
      tableData: [],
      buttonType: false,
      row: {},
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      ruleForm: {},
      rulesDialog: {},
    };
  },
  methods: {
    //查询
    onCheck() {
      this.getAllChildrenPolicyListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form,
      });
      this.$message({
        message: "查询成功",
        type: "success",
      });
    },
    //重置
    onReset() {
      this.form = {};
      this.getAllChildrenPolicyListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      this.$message({
        message: "重置成功",
        type: "success",
      });
    },
    //每页请求${val}条数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAllChildrenPolicyListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      });
    },
    //请求第${val}页数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getAllChildrenPolicyListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      });
    },
    //拿到列表
    getAllChildrenPolicyListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      helpManageFamilyLogList(params).then((res) => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //新增按钮
    add() {
      this.visible = true;
      this.title = "新增";
    },
    //编辑
    compile(e) {
      this.$router.push({
        path: "/addOldManFile",
        querys: {
          row: e,
          buttonType: "compile",
        },
      });
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          helpManageRecordDelete({ id: e.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.provideManageAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  created() {
    this.getAllChildrenPolicyListAPI({
      pageNo: 1,
      pageSize: 10,
    });
  },
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
  padding: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 50%;
  display: inline-block;
  float: right;
}
.el-form-item__label {
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.el-radio {
  margin: 10px;
}
.button-mid {
  width: 300px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
}
</style>
